import { render, staticRenderFns } from "./VvSwitch.vue?vue&type=template&id=f93e1b10&scoped=true&"
import script from "./VvSwitch.vue?vue&type=script&lang=js&"
export * from "./VvSwitch.vue?vue&type=script&lang=js&"
import style0 from "./VvSwitch.vue?vue&type=style&index=0&id=f93e1b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93e1b10",
  null
  
)

export default component.exports